export default __webpack_public_path__ + "static/media/logo-mooncake.ece0ba60.png";